(() => {
  if (!/^\/products\/brush2\/?$/.test(location.pathname)) return;
  const blockId = 'b8caa5ca-9d09-448f-894a-37202d6de278';
  let pending = false;
  let tier = '1';
  const update = () => {
    pending = false;
    const block = document.querySelector(`kaching-bundles-block[deal-block-id="${blockId}"]`);
    if (!block) return;
    const bars = [...block.querySelectorAll('.kaching-bundles__bar')];
    const info = bars.map(bar => {
      const node = bar.querySelector('.kaching-bundles__bar-title');
      const title = bar.dataset.wehOfferTitle || node?.textContent.trim() || '';
      if (/^(100g|300g)\s*—/.test(title)) {
        bar.dataset.wehOfferTitle = title;
        const visibleTitle = title.replace(/^[^—]+—\s*/, '');
        if (node && node.textContent.trim() !== visibleTitle) node.textContent = visibleTitle;
      }
      return {bar, title};
    });
    if (info.filter(x => /^(100g|300g)\s*—/.test(x.title)).length !== 6) return;
    const capacity = document.querySelector('input[data-option-name="Capacity"]:checked')?.value;
    if (!['100g', '300g'].includes(capacity)) return;
    const visible = [];
    for (const {bar, title} of info) {
      const match = title.startsWith(capacity + ' —');
      const display = match ? '' : 'none';
      if (bar.style.display !== display) bar.style.display = display;
      if (bar.getAttribute('aria-hidden') !== String(!match)) bar.setAttribute('aria-hidden', String(!match));
      if (!match) continue;
      visible.push(bar);
      const products = bar.querySelector('.kaching-bundles__bundle-products');
      if (products && products.style.display !== 'none') products.style.display = 'none';
      for (const select of bar.querySelectorAll('select[data-name="Capacity"]')) {
        if (select.value !== capacity) {
          select.value = capacity;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
    }
    if (!visible.some(bar => bar.classList.contains('kaching-bundles__bar--selected'))) {
      const preferred = visible.find(bar => bar.querySelector('.kaching-bundles__bar-title')?.textContent.includes('Buy ' + tier + ' Get')) || visible[0];
      preferred?.querySelector('.kaching-bundles__bar-main')?.click();
    }
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  document.addEventListener('change', schedule);
  document.addEventListener('click', event => {
    const title = event.target.closest('.kaching-bundles__bar')?.querySelector('.kaching-bundles__bar-title')?.textContent;
    const match = title?.match(/Buy (\d) Get/);
    if (match) tier = match[1];
    schedule();
  });
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true});
  schedule();
})();
